import HighchartsReact from "highcharts-react-official";
import React, { ReactNode } from "react";
import Highcharts from "highcharts";
import HCMap from "highcharts/modules/map";
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';

HCMap(Highcharts);
NoDataToDisplay(Highcharts);

interface HighChartProps {
  options: any;
  constructorType?: string
  classes?: string
  children?: ReactNode
}

const HighChart: React.FC<HighChartProps> = (props) => {

  Highcharts.setOptions({
    lang: {
      noData: `
        <div style="text-align: center; color:#909090">
          <h5>No Data Available</h2>
        </div>
      `,
    },
    noData: {
      position: {
        x: 0,
        y: 0,
        align: "center",
        verticalAlign: "middle",
      },
      style: {
        fontWeight: "bold",
        fontSize: "16px",
        color: "#303030",
      },
      useHTML: true,
    },
  });

  return (
    <div className={`${props.classes || 'charts'}`}>
      <HighchartsReact
        highcharts={Highcharts}
        options={props?.options}
        constructorType={"mapChart"}
      />
      {props.children}
    </div>
  );
};

export default HighChart;
